<h2 mat-dialog-title>{{ 'PRODUCT.USERADMIN.SUMMARIZE' | translate }}</h2>
@let dataValue = data();
<mat-dialog-content>
  @if (dataValue.length > 0) {
    <h3>{{ 'PRODUCT.USERADMIN.THESECHANGES' | translate }}:</h3>
    <table>
      @for (detail of dataValue; track $index) {
        <tr>
          <td>
            {{ 'PRODUCT.USERADMIN.' + detail.name + '.TITLE' | translate }}:
          </td>
          <td>
            @for (field of detail.changedFields; track $index) {
              <mat-chip-option>
                {{
                  'PRODUCT.USERADMIN.' + detail.name + '.' + (field | uppercase)
                    | translate
                }}
              </mat-chip-option>
            }
            &nbsp;
          </td>
        </tr>
      }
    </table>
  } @else {
    {{ 'PRODUCT.USERADMIN.NOCHANGES' | translate }}
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button class="btn-app-next" mat-dialog-close>
    {{ 'PRODUCT.USERADMIN.CONTINUE_EDITING' | translate }}
  </button>
  @if (dataValue.length > 0) {
    <button
      mat-raised-button
      class="btn-app-save"
      [mat-dialog-close]="true"
      cdkFocusInitial>
      {{ 'PRODUCT.USERADMIN.SAVE_CHANGES' | translate }}
    </button>
  }
</mat-dialog-actions>
